import {pull, forEach, filter, find, map, isUndefined, extend, uniq, uniqBy, sortBy, get, reverse} from 'lodash';

export class Collection {
    constructor(items, meta) {
        this.items = items || [];
        this.meta = meta || {};
    }

    get length() {
        return this.count();
    }

    get isEmpty() {
        return this.length === 0;
    }

    get(index) {
        return this.items[index];
    }

    has(index) {
        return !isUndefined(this.items[index]);
    }

    count() {
        return this.items.length;
    }

    add(items) {
        if (isUndefined(items.forEach) && !this.contains(items)) {
            this.items.push(items);

            return this;
        }

        items.forEach((item) => this.add(item));

        return this;
    }

    remove(item) {
        pull(this.items, item);

        return this;
    }

    removeAll() {
        this.items = [];

        return this;
    }

    forEach(callback) {
        return forEach(this.items, callback);
    }

    filter(callback) {
        const items = filter(this.items, callback);
        const collection = new Collection(items);

        collection.meta = this.meta;

        return collection;
    }

    find(predicate) {
        return find(this.items, predicate);
    }

    contains(value) {
        return Boolean(find(this.items, (item) => item === value));
    }

    map(callback) {
        return new Collection(
            map(this.items, callback),
            this.meta
        );
    }

    property(name) {
        return this.map((item) => get(item, name));
    }

    mergeWith(collection) {
        if (collection instanceof Collection === false) {
            throw new TypeError(`Expected merged object to be collection, ${collection.constructor.name} given.`);
        }

        this.add(collection.items);
        this.meta = extend(this.meta, collection.meta);

        return this;
    }

    first() {
        return this.get(0);
    }

    unique(fieldName) {
        if (fieldName === undefined) {
            return new Collection(uniq(this.items));
        }

        return new Collection(uniqBy(this.items, fieldName));
    }

    sort(fieldNameOrFunction) {
        return new Collection(sortBy(this.items, fieldNameOrFunction), this.meta);
    }

    reverse() {
        return new Collection(reverse([...this.items]), this.meta);
    }

    toArray() {
        return this.items;
    }

    static async promise(data) {
        return new Collection(await data);
    }

    static from(collection) {
        const newCollection = new Collection();

        if (collection instanceof Collection) {
            newCollection.mergeWith(collection);
        } else {
            newCollection.add(collection);
        }

        return newCollection;
    }
}
